export enum ExecutionTypeCertificationRequest {
    INHOUSE,
    EXTERNAL
}
